import React from 'react';

import { MainProgressBarContainer } from '../BenfitsBreakDown.styles';

const SEGMENT = 100 / 3; // Divide main bar into 3 equal segments for A-D, E, and F-G categories
const ACTIVE_WIDTH = 100 / 6; // Active bar width for A-D category (half of the segment to fit within it)
const STEP = 100 / 18; // Step size for each status within A-D category

export default function TotalCostOfCareProgressBar({
  status,
}: {
  status: string;
}) {
  let activeStyle: React.CSSProperties | null = null;

  // BELOW AVERAGE (A–D)
  if (['A', 'B', 'C', 'D'].includes(status)) {
    const index = ['A', 'B', 'C', 'D'].indexOf(status);
    activeStyle = {
      left: `${index * STEP}%`,
      width: `${ACTIVE_WIDTH}%`,
      background: '#007000',
    };
  }

  //  AVERAGE (E)
  if (status === 'E') {
    activeStyle = {
      left: `${SEGMENT}%`,
      width: `${SEGMENT}%`,
      background: '#196ECF',
    };
  }

  //  ABOVE AVERAGE (F–G)
  if (['F', 'G'].includes(status)) {
    const index = status === 'F' ? 0 : 1;
    activeStyle = {
      left: `${SEGMENT * 2 + index * ACTIVE_WIDTH}%`,
      width: `${ACTIVE_WIDTH}%`,
      background: '#990000',
    };
  }

  return (
    <div style={{ width: '100%' }}>
      <MainProgressBarContainer>
        <div style={{ width: `${SEGMENT}%`, background: '#F0F9ED' }} />
        <div style={{ width: 0.5, background: '#7D7F81' }} />
        <div style={{ width: `${SEGMENT}%`, background: '#EEF4FF' }} />
        <div style={{ width: 0.5, background: '#7D7F81' }} />
        <div style={{ width: `${SEGMENT}%`, background: '#FCF0F0' }} />

        {activeStyle && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              height: '100%',
              ...activeStyle,
            }}
          />
        )}
      </MainProgressBarContainer>
    </div>
  );
}
